import React from 'react';
import styled from 'styled-components';
import Check from '@catalogo/ui-americanas-desktop-svg/icon-check.svg';

export const FormCheckbox = ({ checked, onClick }) => (
  <IconWrapper selected={checked} onClick={onClick}>
    <Check width="12px" height="12px" />
  </IconWrapper>
);

const IconWrapper = styled.div`
  cursor: pointer;
  align-items: center;
  display: flex;
  width: 18px;
  height: 18px;
  padding: 2px;
  background: ${({ theme, selected }) => (selected ? theme.primaryColor : theme.white)};
  border: 1px solid ${({ theme, selected }) => (selected ? theme.primaryColor : '#999')};
  fill: #fff;
`;
